import { Component, OnInit, Input } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { JobService } from 'src/app/core/services/job.service';

@Component({
  selector: 'app-notifications-page',
  templateUrl: './notifications-page.component.html',
  styleUrls: ['./notifications-page.component.css']
})
export class NotificationsPageComponent implements OnInit {

  @Input() $transition$: any;

  stateParams: any;
  searchObject: any;
  context: String;
  contextLabel: String;
  userNotificationControls: any;
  numberOfNewNotifications: Number = 0;
  jobTypeList: any[] = [];
  salaryDurationOptions: any[] = [];

  viewAllNotifications: boolean = false;
  showFiltersFlag: boolean = true;

  constructor(
    private authService: AuthService,
    private $state: StateService,
    private jobService: JobService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  ngOnInit() {
    this.stateParams = this.$transition$.params();
    if (_.isNull(this.stateParams.searchObject)) {
      this.searchObject = {};
      this.searchObject.page = 1;
      this.searchObject.size = 20;
      this.searchObject.companyId = this.authService.getUserDetails().company.companyId;
      this.searchObject.notifyOn = 'GLOBAL';
    } else {
      this.searchObject = this.stateParams.searchObject;
      this.searchObject.page = 1;
      this.searchObject.size = 20;
    }
    if (_.isNull(this.stateParams.context)) {
      this.context = 'global';
    } else {
      this.context = this.stateParams.context;
    }
    this.contextLabel = '';
    if (this.context == 'candidateCard') {
      this.contextLabel = 'Candidate Card Notifications';
    } else if (this.context == 'candidateJobMatchCard') {
      this.contextLabel = 'Candidate Job Card Notifications';
    } else if (this.context == 'requisitionCard') {
      this.contextLabel = 'Requisition Card Notifications';
    }
    this.userNotificationControls = {};
    this.userNotificationControls.setNewNotificationsAsViewed = null;
    this.getSalaryDurationOptions();
    this.getAllPreferredJobTypes();

  }

  redirectToUrl(url, isReloadRequired) {
    this.$state.go(url, null, { reload: isReloadRequired });
  }

  getSalaryDurationOptions() {
    this.jobService.getSalaryDurationOptions((data) => {
      this.salaryDurationOptions = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  getAllPreferredJobTypes() {
    this.jobService.getAllJobTypes((data) => {
      this.jobTypeList = data;
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    })
  }

}
